import React from 'react';
import jcb from 'assets/images/jcb.svg';
import { SvgIconProps } from '@mui/material';

export const AfJcbIcon: React.FC<SvgIconProps> = () => {
  return <img src={jcb} />;
};
